module.exports = __webpack_public_path__ + "img/backcountry_skiing.e2803262.jpeg";